import '@remento-analytics/host/@types';

import { registerActivityHandler } from '@remento/web-analytics-router/sources/activity/activity-handler';
import { registerActivityPlugin } from '@remento/web-analytics-router/sources/activity/activity-plugin';
import { registerClickHandler } from '@remento/web-analytics-router/sources/click/click-handler';
import { registerClickObserver } from '@remento/web-analytics-router/sources/click/click-observer';
import { registerEmailFormHandler } from '@remento/web-analytics-router/sources/form/form-handler';
import { registerActivityTransform } from '@remento/web-analytics-router/transforms/activity';
import { registerCookiesTransform } from '@remento/web-analytics-router/transforms/cookies';
import { registerPageTransform } from '@remento/web-analytics-router/transforms/page';
import { waitForCELoaded } from '@remento/web-analytics-router-crazyegg/init';
import { registerCETransform } from '@remento/web-analytics-router-crazyegg/transforms/page';
import { waitForWisepopsLoaded } from '@remento/web-analytics-router-wisepops/init';
import { registerWisepopsEmailFormsObserver } from '@remento/web-analytics-router-wisepops/sources/form-observer';
import { waitForDocumentLoaded } from '@remento/web-utils/dom/document';
import { initializeHost } from '@remento-analytics/host/init';

import { registerWebflowEmailFormsObserver } from './analytics-router/form-observer.js';

async function initialize() {
  const source = process.env.RO_ANALYTICS_SOURCE!;
  await initializeHost(async (router, analytics, debug) => {
    registerActivityPlugin(router, source, 20 * 1000, 10 * 1000);

    registerCookiesTransform(router);
    registerPageTransform(router, source, window.ANALYTICS_PAGE, window.ANALYTICS_PROPERTIES);
    registerActivityTransform(router);

    registerClickHandler(router, analytics);
    registerEmailFormHandler(router, analytics);
    registerActivityHandler(router, analytics);

    const docLoadedPromise = waitForDocumentLoaded().then(() => {
      registerClickObserver(router, debug);
      registerWebflowEmailFormsObserver(router, debug);
    });
    const wisepopsLoadedPromise = waitForWisepopsLoaded().then(() => {
      registerWisepopsEmailFormsObserver(router, debug);
    });
    waitForCELoaded().then(() => {
      registerCETransform(router);
    });
    debug?.registerInitDependency(docLoadedPromise);
    debug?.registerInitDependency(wisepopsLoadedPromise);
  });
}

(() => {
  Promise.resolve()
    .then(() => initialize())
    .catch((err) => console.error('INIT_ERROR', err));
})();
